import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { CategorieDocumente, CategorieDocumenteEditPayload } from '../categorii-documente.interface';
import { CategoriiDocumenteService } from '../categorii-documente.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize } from 'rxjs';
import { Generic } from 'src/app/interfaces/generic.interface';

@Component({
    selector: 'app-edit-categorii-documente',
    templateUrl: './edit-categorii-documente.component.html',
    styleUrls: ['./edit-categorii-documente.component.scss']
})
export class EditCategoriiDocumenteComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;
    categoriiDocumente: Generic[] = [];

    token!: string;
    isLoading = false;
    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.data.name, [Validators.required]),
        id_parent: new FormControl(this.data.data.id_parent),
        slug: new FormControl(this.data.data.slug, [Validators.required]),
        content: new FormControl(this.data.data.content, [Validators.required]),
        observations: new FormControl(this.data.data.observations),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<EditCategoriiDocumenteComponent>,
        private categoriiDocumenteService: CategoriiDocumenteService,
        private notificationService: NotificationService,
        private authService: AuthService,
    ) {
        this.processToken();
        this.categoriiDocumente = data.categoriiDocumente;
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.categoriiDocumenteService.setToken(token);
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name, id_parent, slug, content, observations } = this.form
            .value as CategorieDocumente;
        const updateCategorie: CategorieDocumenteEditPayload = {
            id: this.data.id,
            name,
            id_parent,
            slug,
            content,
            observations,
        };

        this.categoriiDocumenteService
            .updateCategorie(updateCategorie)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    onHttpError(res: any) {
        if (res.errors && res.errors.message && res.errors.message.length > 0) {
            res.errors.message.forEach((msg: string) => {
                this.notificationService.warningSwal(
                    this.errorTitle,
                    msg,
                    this.errorIcon
                );
            });
        } else {
            let msg;
            try {
                // try to catch the message from server
                msg = res.error.errors.message[0];
            } catch (error) {
                // controll output message
                msg = helper.dialogConfig.generalMessages.error;
            }
            this.notificationService.warningSwal(
                this.errorTitle,
                msg,
                this.errorIcon
            );
        }
    }
}
